module.exports = __webpack_public_path__ + "img/industry3_active.387a27c7.png";